import { useMutation, useQueryClient } from '@tanstack/react-query'
import { websiteService } from '../services/api/websiteService'

export const useWebsite = () => {
  const queryClient = useQueryClient()

  // Create website mutation
  const createWebsiteMutation = useMutation({
    mutationFn: (websiteData) => websiteService.createWebsite(websiteData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['websites'] })
    },
  })

  // Update website mutation
  const updateWebsiteMutation = useMutation({
    mutationFn: ({ id, data }) => websiteService.updateWebsite(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['websites'] })
    },
  })

  // Delete website mutation
  const deleteWebsiteMutation = useMutation({
    mutationFn: (id) => websiteService.deleteWebsite(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['websites'] })
    },
  })

  // Test connection mutation
  const testConnectionMutation = useMutation({
    mutationFn: (id) => websiteService.testConnection(id),
  })

  // Get website scans mutation
  const getWebsiteScansMutation = useMutation({
    mutationFn: ({ websiteId, page = 1, limit = 10 }) =>
      websiteService.getWebsiteScans(websiteId, { page, limit }),
  })

  return {
    // Get all websites
    getAllWebsites: async (filters = {}, pagination = {}) => {
      return queryClient.fetchQuery({
        queryKey: ['websites', filters, pagination],
        queryFn: () => websiteService.getAllWebsites(filters, pagination),
      })
    },

    // Create website
    createWebsite: createWebsiteMutation.mutate,
    isCreating: createWebsiteMutation.isPending,
    createError: createWebsiteMutation.error,
    createData: createWebsiteMutation.data,

    // Update website
    updateWebsite: updateWebsiteMutation.mutate,
    isUpdating: updateWebsiteMutation.isPending,
    updateError: updateWebsiteMutation.error,
    updateData: updateWebsiteMutation.data,

    // Delete website
    deleteWebsite: deleteWebsiteMutation.mutate,
    isDeleting: deleteWebsiteMutation.isPending,
    deleteError: deleteWebsiteMutation.error,
    deleteData: deleteWebsiteMutation.data,

    // Test connection
    testConnection: testConnectionMutation.mutate,
    isTesting: testConnectionMutation.isPending,
    testError: testConnectionMutation.error,
    testData: testConnectionMutation.data,

    // Get website scans
    getWebsiteScans: getWebsiteScansMutation.mutate,
    isGettingWebsiteScans: getWebsiteScansMutation.isPending,
  }
}
